import React from 'react';
import { CheckIcon, GlobeIcon, ShieldCheckIcon, BookOpenIcon, GiftIcon, FlameIcon } from 'lucide-react';
import { offerChecks, IMAGES } from '../data/content';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
const SPOTS_LEFT = 7;
const CLAIMED_PERCENT = 94;
export function Offer() {
  return <section id="offer" className="w-full bg-navy-deep px-4 py-14 md:py-20" data-id="element-177" data-mp="1hoxv5krkv7t6">
      <div className="mx-auto max-w-2xl" data-id="element-178" data-mp="tzwghfs5j0fg">
        <div className="text-center" data-id="element-179" data-mp="u0xtvqwn3z0c">
          <span className="inline-block rounded-full bg-gold px-4 py-1.5 font-display text-lg font-extrabold uppercase tracking-wide text-navy" data-id="element-180" data-mp="p0a2h44i1g5l">
            Special launch offer
          </span>
          <h2 className="mt-4 font-display text-[2.1rem] font-extrabold uppercase leading-[1.02] text-white sm:text-5xl" data-id="element-181" data-mp="yxesxg5dnxs7">
            Everything you need to organize your case evaluations
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-2xl" data-id="element-182" data-mp="2adwgsruwss38">
          <img src={IMAGES.mockup} alt="Complete Blueprint collection with all bonuses" className="w-full bg-sky" data-id="element-183" data-mp="pkqmk69sdn86" />

          <div className="p-5 sm:p-8" data-id="element-184" data-mp="uiimnnkl4fng">
            <ul className="space-y-4" data-id="element-185" data-mp="uhh4z092cuwr">
              <li className="flex gap-3 border-b border-line pb-4" data-id="element-186" data-mp="zhvbgdv0nwso">
                <BookOpenIcon className="mt-0.5 h-6 w-6 shrink-0 text-teal-dark" aria-hidden="true" data-id="element-187" data-mp="zgk82f5hgr23" />
                <div className="flex-1" data-id="element-188" data-mp="13hnop3vcur4d">
                  <p className="font-bold leading-snug text-navy" data-id="element-189" data-mp="6uiqg84i7x1h">Case Decision Blueprint™ — 6 specialized volumes</p>
                  <p className="mt-1 text-sm text-muted" data-id="element-190" data-mp="btlwnvw809b1">
                    Assessment, mixed dentition, diagnostic reasoning, appliance comparison, decision pathways, and
                    follow-up documentation.
                  </p>
                </div>
                <s className="shrink-0 font-semibold text-muted" data-id="element-191" data-mp="3k8vvmv4tcyel">$59</s>
              </li>
              <li className="flex gap-3 border-b border-line pb-4" data-id="element-192" data-mp="3oa7i4rse53ik">
                <GiftIcon className="mt-0.5 h-6 w-6 shrink-0 text-danger" aria-hidden="true" data-id="element-193" data-mp="3o8eab961kd8z" />
                <div className="flex-1" data-id="element-194" data-mp="vdwciovnpmon">
                  <p className="font-bold leading-snug text-navy" data-id="element-195" data-mp="qgxl4e3dntu5">5 exclusive clinical bonuses</p>
                  <p className="mt-1 text-sm text-muted" data-id="element-196" data-mp="155agb8un58nl">
                    Case studies, assessment worksheets, appliance atlas, red flags checklist, and documentation kit.
                  </p>
                </div>
                <s className="shrink-0 font-semibold text-muted" data-id="element-197" data-mp="cg39lml19cr9">$80</s>
              </li>
            </ul>

            <p className="mt-5 text-center text-base text-muted" data-id="element-198" data-mp="7itk66xn913f">
              Total suggested reference value: <s className="font-bold text-danger" data-id="element-199" data-mp="lim5tnubcr4j">$139</s>
            </p>

            <div className="mt-4 text-center" data-id="element-200" data-mp="hfg5sxxsnw6i">
              <p className="text-sm font-bold uppercase tracking-wide text-navy" data-id="element-201" data-mp="heo7vggq5md2">Today, get everything for just</p>
              <p className="mt-1 font-display text-[5.5rem] font-extrabold leading-none text-cta sm:text-8xl" data-id="element-202" data-mp="1wyszk5ruvmri">
                $27<span className="ml-1 text-3xl text-navy" data-id="element-203" data-mp="20engu9z5femr">USD</span>
              </p>
              <p className="mt-1 text-sm font-semibold uppercase tracking-wide text-muted" data-id="element-204" data-mp="20gqeng6jmc21">One-time payment</p>
            </div>

            <ul className="mx-auto mt-6 grid max-w-md gap-2.5 sm:grid-cols-2" data-id="element-205" data-mp="1qgpwvyobo3zy">
              {offerChecks.map(c => <li key={c} className="flex items-center gap-2.5" data-id="element-206" data-mp="1vglzpula9pdx">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success" data-id="element-207" data-mp="2j5eydytaibc8">
                    <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-208" data-mp="2o4riwcwov6bn" />
                  </span>
                  <span className="text-sm font-medium text-ink" data-id="element-209" data-mp="29ekayr4b55p7">{c}</span>
                </li>)}
            </ul>

            <CTAButton className="mt-8" label="Get instant access — $27" data-id="element-210" data-mp="2ecc23ix4onsc" />

            <div className="mt-6 flex justify-center" data-id="element-211" data-mp="3237t4dtrfeyj">
              <Countdown data-id="element-212" data-mp="36ug1r7n9mwan" />
            </div>

            <div className="mx-auto mt-6 w-full max-w-md rounded-2xl border-2 border-danger-line bg-danger-soft p-4" data-id="element-213" data-mp="36walwjqpqkdo">
              <p className="flex items-center justify-center gap-2 text-center text-base font-bold text-danger" data-id="element-214" data-mp="1j4bg1ek8bvhy">
                <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-215" data-mp="1e9o0w6b48dg1" />
                Only {SPOTS_LEFT} spots left at the promotional price!
              </p>
              <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={CLAIMED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-216" data-mp="14aopifyyu3pc">
                <div className="h-full rounded-full bg-danger" style={{
                width: `${CLAIMED_PERCENT}%`
              }} data-id="element-217" data-mp="1s4zxykcqug04" />
              </div>
              <p className="mt-2 text-center text-xs font-semibold text-ink" data-id="element-218" data-mp="2kn3ui07l48e7">
                {CLAIMED_PERCENT}% of promotional spots already claimed
              </p>
            </div>

            <div className="mx-auto mt-5 flex max-w-md items-start gap-3 rounded-2xl bg-sky p-4" data-id="element-219" data-mp="2o5b1j3qvnex2">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal-dark" aria-hidden="true" data-id="element-220" data-mp="2s6wm7b9nkxht" />
              <p className="text-sm leading-relaxed text-ink" data-id="element-221" data-mp="2x5zfjyg9tf9y">
                <strong data-id="element-222" data-mp="2x4emkd9lu4e7">Automatic currency conversion:</strong> your payment provider converts the price into your local
                currency automatically at checkout.
              </p>
            </div>

            <p className="mt-5 flex items-center justify-center gap-2 text-center text-sm font-medium text-muted" data-id="element-223" data-mp="373x30jqb381i">
              <ShieldCheckIcon className="h-4 w-4 text-success" aria-hidden="true" data-id="element-224" data-mp="3b3e99fdk497q" />
              7-day money-back guarantee · No recurring charges
            </p>
          </div>
        </div>
      </div>
    </section>;
}